import { Link } from 'react-router-dom';
import { LogoIcon } from '@/assets/icons';
import { ROUTES } from '@/constants';
import { smoothScrollToTop } from '@/utils/utils';

export function NavbarLogo() {
  return (
    <Link
      to={ROUTES.admin}
      onClick={smoothScrollToTop}
      className="relative mx-auto block"
    >
      <LogoIcon />

      <span className="sr-only">HLB</span>
    </Link>
  );
}
